module.exports = __webpack_public_path__ + "img/green.22500d31.svg";